import { render, staticRenderFns } from "./invitePaperApply.vue?vue&type=template&id=1d41a4ef&"
import script from "./invitePaperApply.vue?vue&type=script&lang=js&"
export * from "./invitePaperApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports